import React from 'react'
import styled from 'styled-components'
import { TrashIcon } from '@mote/assets/icons'

export const AccountProfileDeleteAvatarOverlay = ({ onDeleteAvatar, url }) => {
  if (url.includes('googleusercontent.com')) {
    return null
  }
  return (
    <Root onClick={onDeleteAvatar} url={url}>
      <TrashIcon color='white' />
    </Root>
  )
}

const Root = styled.div`
  position: absolute;
  width: 80px;
  height: 80px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 45px;
  display: grid;
  place-items: center;
  opacity: 0;

  &:hover {
    cursor: ${({ url }) => (url ? 'pointer' : 'default')};
    opacity: ${({ url }) => (url ? 1 : 0)};
  }
`
